import React from 'react';
export const getShape = (shape = 'circle') => {
    if (shape === 'square') {
        return (React.createElement("path", { d: "M49.056 59.952 6.968 53.086a3.532 3.532 0 0 1-2.918-4.081l6.809-42.04a3.535 3.535 0 0 1 4.085-2.915l42.088 6.866a3.532 3.532 0 0 1 2.918 4.08l-6.809 41.977c-.26 1.943-2.14 3.303-4.085 2.98Z", fill: 'var(--color-primary-70)' }));
    }
    if (shape === 'triangle') {
        return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.945 5.025 58.32 45.033c1.898 1.56 2.243 4.556.748 6.553-.69.936-1.668 1.56-2.76 1.748l-41.57 6.615c-2.357.375-4.542-1.373-4.887-3.994v-.062L4.045 9.332C3.7 6.772 5.368 4.4 7.725 4.027c1.15-.125 2.3.187 3.22.998Z", fill: 'var(--color-feedback-success-80)' }));
    }
    return (React.createElement("path", { d: "M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28Z", fill: 'var(--color-secondary-70)' }));
};
export const getColor = (shape = 'circle') => {
    if (shape === 'square') {
        return 'var(--color-primary-100)';
    }
    if (shape === 'triangle') {
        return 'var(--color-feedback-success-90)';
    }
    return 'var(--color-secondary-100)';
};
